import { common } from "./_common";
import { header } from "./_header";
import { slide } from "./_slide";
import { scroll } from "./_scroll";
import { animation } from "./_animation";

animation();
scroll();
slide();
header();
common();
